import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { QuestionBaseComponent } from '@core/form-generator-engine/abstractions/question-base-component';
import { QuestionControl } from '@core/form-generator-engine/composite-pattern';
import { yesNoItems } from '@core/form-generator-engine/helpers/yes-no-items';
import { YesNoItem } from '@core/form-generator-engine/typing/yes-no-item';
import { DropdownItem } from '@shared/abstraction';

@Component({
  standalone: false,
  selector: 'gstar-yes-no',
  templateUrl: './yes-no.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class YesNoComponent implements QuestionBaseComponent, OnInit {
  @Input() question!: QuestionControl;

  value!: YesNoItem;

  options: YesNoItem[] = yesNoItems;

  ngOnInit(): void {
    if (this.question.getValue() !== undefined) {
      const value = this.options.find(
        (option: DropdownItem) => option.value === this.question.getValue()
      )!;

      this.value = {
        ...value,
        checked: true,
        focused: false,
      };
    }
  }

  update(updatedState: DropdownItem): void {
    this.question.control.setValue(updatedState.value);
  }
}
